const relationshipOptions = {
    male_older: {
        ko: '남성 (연상)',
        vi: 'Nam (lớn tuổi)',
        en: 'Male (older)'
    },
    male_same_age: {
        ko: '남성 (동년배)',
        vi: 'Nam (bằng tuổi)',
        en: 'Male (same age)'
    },
    male_younger: {
        ko: '남성 (연하)',
        vi: 'Nam (nhỏ tuổi)',
        en: 'Male (younger)'
    },
    female_older: {
        ko: '여성 (연상)',
        vi: 'Nữ (lớn tuổi)',
        en: 'Female (older)'
    },
    female_same_age: {
        ko: '여성 (동년배)',
        vi: 'Nữ (bằng tuổi)',
        en: 'Female (same age)'
    },
    female_younger: {
        ko: '여성 (연하)',
        vi: 'Nữ (nhỏ tuổi)',
        en: 'Female (younger)'
    },
    male_lover: {
        ko: '남성 (연인)',
        vi: 'Nam (người yêu)',
        en: 'Male (lover)'
    },
    female_lover: {
        ko: '여성 (연인)',
        vi: 'Nữ (người yêu)',
        en: 'Female (lover)'
    },
    husband: {
        ko: '남편',
        vi: 'Chồng',
        en: 'Husband'
    },
    wife: {
        ko: '아내',
        vi: 'Vợ',
        en: 'Wife'
    }
};

export const translations = {
    // 앱 기본 정보
    mainTitle: {
        ko: 'KoVn talk',
        vi: 'KoVn talk',
        en: 'KoVn talk'
    },
    languages: {
        korean: {
            ko: '한국어',
            vi: 'Hàn Quốc',
            en: 'Korean'
        },
        vietnamese: {
            ko: '베트남어',
            vi: 'Việt',
            en: 'Vietnamese'
        },
        english: {
            ko: '영어',
            vi: 'Tiếng Anh',
            en: 'English'
        }
    },

    // 버튼 관련 텍스트
    buttons: {
        settings: {
            ko: '필수 설정',
            vi: 'Cài đặt',
            en: 'Settings'
        },
        settingsComplete: {
            ko: '설정 완료',
            vi: 'Hoàn tất cài đặt',
            en: 'Complete Settings'
        },
        clear: {
            ko: '삭제',
            vi: 'Xóa',
            en: 'Clear'
        },
        translate: {
            ko: '번역하기',
            vi: 'Dịch',
            en: 'Translate'
        },
        copy: {
            ko: '번역 복사',
            vi: 'Sao chép',
            en: 'Copy Translation'
        },
        listen: {
            ko: '음성 듣기',
            vi: 'Nghe',
            en: 'Listen'
        },
        swap: {
            ko: '언어 전환',
            vi: 'Hoán đổi ngôn ngữ',
            en: 'Swap Languages'
        },
        showRules: {
            ko: '📜 특별 번역 규칙 보기',
            vi: '📜 Xem quy tắc dịch đặc biệt',
            en: '📜 View Special Translation Rules'
        },
        close: {
            ko: '닫기',
            vi: 'Đóng',
            en: 'Close'
        }
    },

    // 설정 화면 관련 텍스트
    settings: {
        title: {
            ko: '번역 설정',
            vi: 'Cài đặt dịch thuật',
            en: 'Settings'
        },
        speakerLabel: {
            ko: '글자를 입력하는 사람',
            vi: 'Người nhập văn bản',
            en: 'Speaker'
        },
        listenerLabel: {
            ko: '번역 결과를 보는 사람',
            vi: 'Người xem kết quả',
            en: 'Listener'
        },
        // 위에서 정의한 공통 옵션을 그대로 사용합니다.
        relationshipOptions: relationshipOptions,
        toneLabel: {
            ko: '대화 톤',
            vi: 'Giọng điệu',
            en: 'Tone'
        },
        toneOptions: {
            friendly: {
                ko: '친근한',
                vi: 'Thân mật',
                en: 'Friendly'
            },
            polite: {
                ko: '정중한',
                vi: 'Lịch sự',
                en: 'Polite'
            },
            business: {
                ko: '사무적',
                vi: 'Công sở',
                en: 'Business'
            }
        },
        regionLabel: {
            ko: '지역 선택',
            vi: 'Vùng miền',
            en: 'Region'
        },
        regionOptions: {
            hanoi: {
                ko: '북부 (하노이)',
                vi: 'Miền Bắc (Hà Nội)',
                en: 'North (Hanoi)'
            },
            hochiminh: {
                ko: '남부 (호치민)',
                vi: 'Miền Nam (Hồ Chí Minh)',
                en: 'South (Ho Chi Minh)'
            }
        },
        styleLabel: {
            ko: '번역 스타일',
            vi: 'Kiểu dịch',
            en: 'Translation Style'
        },
        styleOptions: {
            natural: {
                ko: '의역',
                vi: 'Dịch nghĩa',
                en: 'Natural'
            },
            literal: {
                ko: '직역',
                vi: 'Dịch sát nghĩa',
                en: 'Literal'
            }
        }
    },

    // 특별 번역 규칙 관련 텍스트
    specialRules: {
        title: {
            ko: '특별 번역 규칙',
            vi: 'Quy tắc dịch đặc biệt',
            en: 'Special Translation Rules'
        },
        loverRule: {
            ko: '연인 규칙 (남성→여성)',
            vi: 'Quy tắc người yêu (Nam→Nữ)',
            en: 'Lover rule (Male→Female)'
        },
        spouseRule: {
            ko: '부부 규칙 (남편→아내)',
            vi: 'Quy tắc vợ chồng (Chồng→Vợ)',
            en: 'Spouse rule (Husband→Wife)'
        }
    },

    // 플레이스홀더 및 메시지
    placeholders: {
        source: {
            ko: '번역할 내용을 입력하세요. (언어 자동 감지)',
            vi: 'Vui lòng nhập nội dung cần dịch. (Tự động nhận dạng ngôn ngữ)',
            en: 'Enter text to translate. (Language auto-detection)'
        },
        target: {
            ko: '정확한 베트남어 발음을 듣기 위해서는 Edge 브라우저 사용을 강력히 권장합니다. (구글 크롬 X)',
            vi: 'Để nghe phát âm tiếng Việt chuẩn xác, khuyến khích mạnh mẽ sử dụng trình duyệt Edge. (Không dùng Google Chrome)',
            en: 'For accurate Vietnamese pronunciation, we strongly recommend using the Edge browser. (Not Google Chrome)'
        }
    },
    messages: {
        copySuccess: {
            ko: '복사 성공!',
            vi: 'Đã sao chép!',
            en: 'Copy Success!'
        },
        error: {
            ko: '오류가 발생했습니다. 다시 시도해주세요.',
            vi: 'Đã xảy ra lỗi. Vui lòng thử lại.',
            en: 'An error occurred. Please try again.'
        },
        apiKeyError: {
            ko: 'API 키가 설정되지 않았습니다. 개발자에게 문의하세요.',
            vi: 'Khóa API chưa được thiết lập. Vui lòng liên hệ nhà phát triển.',
            en: 'API key is not set. Please contact the developer.'
        },
        charLimitExceeded: {
            ko: '글자 수 제한 초과',
            vi: 'Vượt quá giới hạn ký tự',
            en: 'Character limit exceeded'
        }
    }
};